export default {
  methods: {
    /**
     * Triggers event
     * @param {string} eventName
     * @param {HTMLElement|Document} el
     * @param {any} detail
     * @return {void}
     */
    triggerEvent(eventName, el, detail) {
      let customEvent;

      if (typeof window.CustomEvent === 'function') {
        customEvent = new CustomEvent(eventName, { detail });
      } else {
        customEvent = document.createEvent('CustomEvent');
        customEvent.initCustomEvent(eventName, true, true, detail);
      }

      el.dispatchEvent(customEvent);
    },
  },
};
